import { Component, Input } from '@angular/core';
import { Global } from '../../../lib/classes/global';

@Component({
  selector: 'mj-image-popup',
  templateUrl: './imagePopup.template.html',
  styleUrls: ['./imagePopup.style.scss'],
})
export class ImagePopupComponent {
  @Input() imageUrl: string;
  @Input() classes: string;

  public $g: Global = new Global();
  public classMap: any = {};

  constructor() {}
}
